import { useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { Image } from '../../../../../common/image'
import { formatCurrencyFollowLocale } from '../../../../../helpers/value'
import { CURRENCY } from '../../../../../utils/currency'
import classes from '../../../../index.module.scss'
import FreeSvg from '../../icon/free.svg'

export const SubscriptionFee = ({
  isPremiumOrStandard,
  standardOrPremiumColorScheme,
  isCustom,
  data,
}) => {
  const locale = useSelector((state) => state.i18n.locale)

  const subscriptionFee = (
    <div style={{ height: 70 }}>
      <div
        className={classes.subscriptionFee}
        style={{ backgroundColor: '#F9F9F9' }}
      >
        <div className="fw600">
          <Translate value="userManagement.upgradeViewPlan.SUBSCRIPTION_FEE" />
        </div>
        <div className={classes.imgContainer}>
          <Image src={FreeSvg} className={classes.freeImg} />
          <div
            className={classes.text}
            style={{ fontSize: 9, color: '#FFFFFF' }}
          >
            <Translate value="userManagement.upgradeViewPlan.FREE" />
          </div>
        </div>
      </div>
    </div>
  )

  const subscriptionFeePrice = (
    <div className={classes.subscriptionFeePrice}>
      <div
        className={classes.container}
        style={{
          backgroundColor: standardOrPremiumColorScheme.subscriptionBackground,
        }}
      >
        <div
          className="textUppercase"
          style={{ color: standardOrPremiumColorScheme.text }}
        >
          <Translate value="userManagement.upgradeViewPlan.SUBSCRIPTION_FEE" />
        </div>
        <div>
          <span
            style={{
              fontSize: 10,
              color: standardOrPremiumColorScheme.text,
            }}
          >
            <Translate value="userManagement.upgradeViewPlan.ONLY_FROM" />
          </span>
          <span
            style={{ fontSize: 14, color: standardOrPremiumColorScheme.text }}
          >
            {` ${formatCurrencyFollowLocale(
              data,
              CURRENCY.VND,
              locale,
            )}/${I18n.t('userManagement.upgradeViewPlan.MONTH')}`}
          </span>
        </div>
      </div>
    </div>
  )

  const custom = <div style={{ height: 70 }}></div>

  return isCustom
    ? custom
    : isPremiumOrStandard
    ? subscriptionFeePrice
    : subscriptionFee
}
